import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToHash } from './utils/scrollToHash';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => scrollToHash(hash, 'auto'), 150);
      return () => clearTimeout(timer);
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
